import { COMMON_QUERY_CONFIG, COMMON_QUERY_RULES_CONFIG } from './shared/configs';

enum SECTION_ENUM {
  BARRONS_ADVISOR = 'Barrons Advisor'
}

const BARRONS_ADVISOR = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    and: [
      ...(COMMON_QUERY_RULES_CONFIG.and ?? []),
      { terms: { key: 'BarronsDisplayBrand', value: ['BARBIGQ', 'BARTHINGS', 'BARCOACH', 'BARPROF', 'BARINDADVISOR'] } }
    ]
  }
};

export { SECTION_ENUM, BARRONS_ADVISOR };
